// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveContactDetailHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ContactDTO from '../models/ContactDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    contact: ContactDTO | null;
    additionalFile: any | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            contact: null,
            additionalFile: null,
        },
        initValues);
    },
    contact: 'contact',
    additionalFile: 'additionalFile',
}

interface Result extends ResultDTO {
    contact: ContactDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            contact: null,
        },
        initValues);
    },
    contact: 'contact',
}

export { Request, Result };